module.exports = __webpack_public_path__ + "img/resi.e72bc02a.svg";